import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IDocumentTypesDto } from 'app/main/pages/documents/dto/document-listing.dto';
import { IField } from '../../document-type-settings.dto';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { IMetadataItemDto } from 'app/main/pages/settings/documentfields/metadata-item.dto';

@Component({
  selector: 'app-edit-layout-content',
  templateUrl: './edit-layout-content.component.html',
  styleUrl: './edit-layout-content.component.scss'
})
export class EditLayoutContentComponent {
  
  @Output() updateFieldsOrders = new EventEmitter<{ nestedTab: string, fields: IField[] }>()
  @Output() drop = new EventEmitter<CdkDragDrop<string[]>>();
  @Output() removeFieldFromCustomBox = new EventEmitter<CdkDragDrop<string[]>>();
  @Output() removeCustomBox: EventEmitter<number> = new EventEmitter<number>();
  @Output() addFieldsInCustomBox: EventEmitter<{ boxIndex: number, field: IMetadataItemDto }> = new EventEmitter<{ boxIndex: number, field: IMetadataItemDto }>();
  @Output() renameCustomBox = new EventEmitter<{ boxIndex: number, name: string }>();
  @Output() updateVisibility = new EventEmitter<{boxIndex: number, isVisible: boolean}>();
  @Output() updateLayoutSettings = new EventEmitter<void>();
  @Output() createCustomBox = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  @Input() layoutsetting: IDocumentTypesDto;
  @Input() metaDataItems: IMetadataItemDto[];
  @Input() loading: boolean = false;
}
